import { render, staticRenderFns } from "./SubBeneficiary.vue?vue&type=template&id=44a1ef94"
import script from "./SubBeneficiary.vue?vue&type=script&lang=js"
export * from "./SubBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports